/* ACC_CusbClo_Menu_79: native header redesign behavior.
   Markup is rendered by Liquid (snippets/acc-cusbclo-menu-79-*.liquid). Hover and mobile menu logic is taken from the test script.js. */
(function () {
  var tn = 'ACC_CusbClo_Menu_79';

  function menuHoverFunc() {
    var wrapper = document.querySelector('.' + tn + '_menu_wrapper');
    if (!wrapper) return;

    wrapper.addEventListener('mouseover', function (e) {
      var item = e.target.closest('.' + tn + '_menu_item');
      if (!item) return;

      var key = item.dataset.menu;

      wrapper.querySelectorAll('.' + tn + '_menu_item').forEach(function (el) {
        el.classList.remove('active');
      });
      wrapper.querySelectorAll('.' + tn + '_submenu').forEach(function (el) {
        el.classList.remove('active');
      });

      item.classList.add('active');

      var submenu = wrapper.querySelector('.' + tn + '_submenu[data-menu="' + key + '"]');
      if (submenu) submenu.classList.add('active');
    });

    document.addEventListener('mousemove', function (e) {
      var activeItem = wrapper.querySelector('.' + tn + '_menu_item.active');
      var activeSubmenu = wrapper.querySelector('.' + tn + '_submenu.active');

      if (!activeItem) return;

      var overItem = activeItem.contains(e.target);
      var overSubmenu = activeSubmenu && activeSubmenu.contains(e.target);

      if (!overItem && !overSubmenu) {
        activeItem.classList.remove('active');
        if (activeSubmenu) activeSubmenu.classList.remove('active');
      }
    });
  }

  function mobileMenuFunc() {
    var body = document.body;
    var html = document.documentElement;
    var drawer = document.querySelector('#NavDrawer');
    var menuBtn = document.querySelector('.' + tn + '_mobile_menuButton');
    var mobileMenu = document.querySelector('.' + tn + '_mobile_body');
    var closeBtn = document.querySelector('.' + tn + '_mobile_header .' + tn + '_close');
    var searchBtn = document.querySelector('.' + tn + '_mobile_header .' + tn + '_search');
    var backBtn = document.querySelector('.' + tn + '_submenu_back_btn');
    var searchTrigger = document.querySelector('[data-section-type=header] > .toolbar .header-item .js-search-header');
    if (!mobileMenu) return;

    var submenuItems = Array.prototype.slice.call(
      mobileMenu.querySelectorAll(':scope > .' + tn + '_item.has-submenu')
    );

    function closeSubMenus() {
      submenuItems.forEach(function (item) {
        item.classList.remove(tn + '_show_subMenu');
      });
    }

    function openMenu() {
      body.classList.add(tn + '_show_menu');
      html.classList.add('js-drawer-open');
      if (drawer) drawer.classList.add('drawer--is-open');
    }

    function closeMenu() {
      body.classList.remove(tn + '_show_menu');
      html.classList.remove('js-drawer-open');
      if (drawer) drawer.classList.remove('drawer--is-open');
    }

    if (menuBtn) {
      menuBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        openMenu();
      }, true);
      menuBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openMenu();
        }
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    // rotating / resizing past the mobile breakpoint while the menu is open: close it so no empty drawer is left behind
    if (window.matchMedia) {
      var wide = window.matchMedia('(min-width: 769px)');
      var onWide = function (e) {
        if (e.matches) closeMenu();
      };
      if (wide.addEventListener) wide.addEventListener('change', onWide);
      else if (wide.addListener) wide.addListener(onWide);
    }

    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        closeMenu();
        if (searchTrigger) searchTrigger.click();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && body.classList.contains(tn + '_show_menu')) closeMenu();
    });

    mobileMenu.addEventListener('click', function (e) {
      var head = e.target.closest('.' + tn + '_item_head');
      if (!head) return;

      var item = head.closest('.' + tn + '_item.has-submenu');
      if (!item) return;

      var wasOpen = item.classList.contains(tn + '_show_subMenu');
      closeSubMenus();
      if (!wasOpen) item.classList.add(tn + '_show_subMenu');
    });

    if (backBtn) {
      backBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeSubMenus();
      });
    }

    // Open first submenu by default
    if (submenuItems[0]) submenuItems[0].classList.add(tn + '_show_subMenu');
  }

  // theme.js only wires the first country/language selector on the page (the desktop one in the toolbar).
  // The mobile drawer has its own copy, so bind it here with the theme's own Disclosure class.
  function drawerCountryFunc() {
    var els = document.querySelectorAll(
      '.' + tn + '_country [data-disclosure-currency], .' + tn + '_country [data-disclosure-locale]'
    );
    if (!els.length) return true;
    if (!window.theme || !window.theme.Disclosure) return false;
    els.forEach(function (el) {
      if (el.getAttribute('data-acc-disclosure')) return;
      el.setAttribute('data-acc-disclosure', 'true');
      new window.theme.Disclosure(el);
    });
    return true;
  }

  function init() {
    menuHoverFunc();
    mobileMenuFunc();
    if (!drawerCountryFunc()) {
      window.addEventListener('load', drawerCountryFunc);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
